/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CloudAccountConfiguration {
    getFixupPrototypeFunction() { return CloudAccountConfiguration.fixupPrototype; }

    static newInstance(model: Partial<CloudAccountConfiguration>): CloudAccountConfiguration {
        let obj = Object.assign(new CloudAccountConfiguration(), model);
        CloudAccountConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CloudAccountConfiguration>): CloudAccountConfiguration {
        if (!model) return null;
        return CloudAccountConfiguration.newInstance(<CloudAccountConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CloudAccountConfiguration) {
        if (!obj) return;

        models.CloudAccountConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CloudAccountConfiguration): boolean {
        Object.setPrototypeOf(obj, CloudAccountConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Notify on account access issues
     */
    account_access_issue: boolean;

    /**
     * Notify on Azure credentials expiry
     */
    azure_credentials_expiry: boolean;

    /**
     * Email addresses for cloud account notifications
     */
    email_address: Array<string>;

}
